<template>
    <div class="main">
        <div style="display: inline-block;" v-if="!isConsultant">
            <div class="header_margin">
                <span v-if="undertaking.undertakingId" style="width: 50px; vertical-align: middle;">
                    <router-link :to="{ path: '/Undertaking/' + undertaking.undertakingId }" tag="a" class="fa fa-edit" style="font-size: 16px;"></router-link>
                </span>
                <span class="label">Assigned Undertaking</span>
                <span class="value">{{ undertaking.name ? undertaking.name : 'NOT YET ASSIGNED' }}</span>
                <template v-if="undertaking.undertakingId">
                    <span class="label">DBU</span>
                    <span class="value">{{ undertaking.dbNumber }}</span>
                </template>
            </div>
            <div v-if="undertaking.undertakingId">
                <span class="label" v-if="undertaking.undertakingId">Finding of Effect</span>
                <span class="value">{{ undertaking.effectDescription }}</span>
                <span class="label" v-if="undertaking.undertakingId">Review Framework</span>
                <span class="value">{{ undertaking.reviewFrameworkDescription }}</span>
                <span class="label" v-if="undertaking.undertakingId">Review Timeframe</span>
                <span class="value">{{ undertaking.reviewTimeframeDescription }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import { mapState } from 'vuex'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
export default {
    name: 'undertakingHeader',
    data: function () {
        return {
            isDebug: false
        }
    },
    props: ['undertaking'],
    created () {
        loggingService.log(this.isDebug, 'undertakingHeader', 'created')
    },
    mounted () {
        loggingService.log(this.isDebug, 'undertakingHeader', 'mounted')
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        isConsultant: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ConsultantOnlyRoleList)
        }
    }
}
</script>


<style>
    .main {
        padding: 10px;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        border: 1px solid #cccccc;
        border-radius: 4px;
        background-color: #f5f5f5;
    }
    .label {
        margin-right: 20px;
        color: #555555;
        font-weight: normal;
    }
    .value {
        margin-right: 20px;
        font-weight: bold;
    }
    .header_margin {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// UndertakingHeader.vue?5a44b225